const ENTRY_UNDO_CHANNEL_NAME = "hourglass-entry-undo-history";
const ENTRY_UNDO_LOCK_PREFIX = "hourglass-entry-undo";

type EntryUndoHistoryMessage = {
	type: "history_changed";
	scope: string;
};

export type EntryUndoHistorySync = {
	notify: (scope: string) => void;
	close: () => void;
};

export function createEntryUndoHistorySync(
	onHistoryChanged: (scope: string) => void,
): EntryUndoHistorySync | null {
	if (typeof BroadcastChannel === "undefined") return null;
	const channel = new BroadcastChannel(ENTRY_UNDO_CHANNEL_NAME);
	channel.onmessage = (event: MessageEvent<unknown>) => {
		const message = event.data as Partial<EntryUndoHistoryMessage> | null;
		if (
			message?.type === "history_changed" &&
			typeof message.scope === "string"
		)
			onHistoryChanged(message.scope);
	};
	return {
		notify: (scope) =>
			channel.postMessage({
				type: "history_changed",
				scope,
			} satisfies EntryUndoHistoryMessage),
		close: () => channel.close(),
	};
}

export function withEntryUndoLock<T>(
	scope: string,
	operation: () => Promise<T>,
): Promise<T> {
	const lockManager =
		typeof navigator === "undefined" ? undefined : navigator.locks;
	if (!lockManager) return operation();
	return lockManager.request(
		`${ENTRY_UNDO_LOCK_PREFIX}:${scope}`,
		{ mode: "exclusive" },
		() => operation(),
	);
}
